import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-create-tree-level-dialog',
    template: `
    <form [formGroup]="createTreeLevelForm">
      <div class="flex flex-col mb-2">
        <label for="levelName">{{ levelName | titlecase }} Name</label>
        <input pInputText formControlName="name" id="levelName" (keyup)="handleKeyUp($event)" />
        @if (createTreeLevelForm.controls.name.value.length > 0 && createTreeLevelForm.controls.name.value.length < 3) {
          <p class="validation-error">Must be longer than three characters</p>
        }
      </div>
      @if (levelName == 'company') {
        <p class="validation-error pb-2">After creating a new Company, make sure it's assigned to required users in the Admin panel under their accounts.</p>
      }
      <div style="float:right">
        <button pButton type="button" icon="pi pi-check" class="p-button-text p-button-success"
          [disabled]="createTreeLevelForm.invalid" label="Save" (click)=onSave()></button>
        <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-danger" label="Cancel"
          (click)=onCancel()></button>
      </div>
    </form>
    `,
    standalone: false
})
export class CreateTreeLevelDialogComponent {

  public createTreeLevelForm: UntypedFormGroup;
  public levelName: string;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _ref: DynamicDialogRef,
    private _config: DynamicDialogConfig
  ) {
    this.createTreeLevelForm = this._formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]]
    });

    const level = this._config.data.level;
    this.levelName = level !== 'companies' ? level.slice(0, -1) : 'company';
  }

  handleKeyUp(e: KeyboardEvent){
    if(e.code === "Enter"){
      this.onSave();
   }
  }

  onSave() {
    const formNameValue =this.createTreeLevelForm.get('name').value;
    this._ref.close({name: formNameValue});
  }

  onCancel() {
    this._ref.close();
  }
}
